import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const staleQueriesSlice = createSlice({
    name: 'staleQueries',
    initialState, 

    reducers: {
      
      mark(state, action) {
        state[action.payload] = true;
      },

      clear(state, action) {
        delete state[action.payload];
      },

      clearAll(state, action) {
        return initialState;
      },

      markMany(state, action) {
        action.payload.forEach((query) => {
          state[query] = true;
        });
      }
    }

  });

  export const { 
    mark, markMany, clear, clearAll 
  } = staleQueriesSlice.actions;

  export default staleQueriesSlice.reducer;
